<template>
  <div class="container contact-container">
    <Header :banner="require('@/assets/images/banner/contact.png')" />
    <section class="section section1">
      <div class="contact fa percent80 box-center">
        <div class="address contact-item percent20">
          <div class="icon icon1 box-center fcc">
            <img
              :src="require('@/assets/images/contact/1.png')"
              alt="公司地址"
              class="img"
            />
          </div>
          <div
            class="font-size-22 font-blod text-center mb20"
            style="margin-top: -25px"
          >
            公司地址
          </div>
          <div
            class="font-size-16 font-blod text-center c_888 mb20 break"
          >
            上海闵行区元江路525号
          </div>
          <div
            class="font-size-16 font-blod text-center c_888 break"
          >
            2号楼113室
          </div>
          <div class="button">欢迎咨询</div>
        </div>
        <div class="phone contact-item percent20">
          <div class="icon icon2 box-center fcc">
            <img
              :src="require('@/assets/images/contact/2.png')"
              alt="公司地址"
              class="img"
            />
          </div>
          <div
            class="font-size-22 font-blod text-center mb20"
            style="margin-top: -25px"
          >
            联系电话
          </div>
          <div
            class="font-size-16 font-blod text-center c_888 mb20 break"
          >
            021-34307360
          </div>
          <!-- <div
            
            class="font-size-16 font-blod text-center c_888 break"
          >
            XXXXXXXXXXX
          </div> -->
          <div class="button">联系我们</div>
        </div>
        <div class="email contact-item percent20">
          <div class="icon icon3 box-center fcc">
            <img
              :src="require('@/assets/images/contact/3.png')"
              alt="公司地址"
              class="img"
            />
          </div>
          <div
            class="font-size-22 font-blod text-center mb20"
            style="margin-top: -25px"
          >
            企业邮箱
          </div>
          <div
            class="font-size-16 font-blod text-center c_888 mb20 break"
          >
            admin@woowis.com
          </div>
          <!-- <div
            class="font-size-16 font-blod text-center c_888 break"
          >
            XXXXXXXXX@QQ.COM
          </div> -->
          <div class="button">欢迎咨询</div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Footer,
  },
};
</script>

<style lang="scss" scoped>
.container {
    .section1 {
        margin-top: 100px;
        .contact {
            .contact-item {
                position: relative;
                padding-bottom: 100px;
                border: 1px solid rgba(0,0,0,.2);
                .icon {
                    border-radius: 50%;
                    width: 50%;
                    transform: translateY(-50%);
                    &.icon1 {
                        border: 1px solid #39bbfe;
                    }
                    &.icon2 {
                        border: 1px solid #9af5cf;
                    }
                    &.icon3 {
                        border: 1px solid #d35d77;
                    }
                }
                .button {
                    position: absolute;
                    left: 50%;
                    bottom: 10%;
                    padding: 10px 20px;
                    border-radius: 5px;
                    font-size: 14px;
                    text-align: center;
                    color: #fff;
                    transform: translateX(-50%);
                    cursor: pointer;
                }
                &.address {
                    .button {
                        background-image: linear-gradient(to top right,#46b2fe,#05dffe);
                    }
                }
                &.phone {
                    .button {
                        background-image: linear-gradient(to top right,#25c3e9,#44ffc7);
                    }
                }
                &.email {
                    .button {
                        background-image: linear-gradient(to top right,#f3646e,#f55982);
                    }
                }
            }
        }
    }
}
</style>